import apiClient from "./axios.config";

const FooterSEOLinkServices = {

  getFooterLinks() {
    return apiClient.get(`website/property/seo-locations/footer-links`);
  },
};

export default FooterSEOLinkServices;
